<template>
  <div class="news">
    <Title :msg="wordTitle"></Title>
    <News
    :newscard="news"/>

    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Title from '@/components/title_onecolorbg.vue';
import News from '@/components/news_area.vue';
import Footer from '@/components/footer_information.vue';

export default {
  data() {
    return {
      wordTitle: '新聞快訊',
      newscardContent: [], // reactive
    };
  },
  computed: {
    news() {
      const arr = this.newscardContent;
      return arr.reverse();
    },
  },
  components: {
    Title,
    News,
    Footer,
  },
  created() {
    const api = 'https://brycehuang.com/api/getNews/';
    this.axios.get(api).then((response) => {
      console.log(response.data.data);
      // this.newscardContent = response.data.data;
      response.data.data.forEach((news) => {
        this.newscardContent.push(news);
      });
    });
  },
};
</script>
<style lang="scss" scoped>

</style>
